import noUiSlider from 'nouislider';

export default angular.module('nouislider', [])
  .directive('nouislider', function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        options: '=',
        ngModel: '='
      },
      template: '<div></div>',
      link: function (scope, element) {
        let slider = element[0];
        let parseVal = (val) => parseFloat(val, 10);

        noUiSlider.create(slider, _.merge(
          {},
          scope.options,
          {start: scope.ngModel}
        ));

        slider.noUiSlider.on('set', (newValue) => {
          if (!scope.$$phase && !scope.$root.$$phase) {
            scope.$apply(() => {
              scope.ngModel = newValue.map(parseVal);
            });
          }
        });

        scope.$watch('ngModel', function (newVal) {
          slider.noUiSlider.set(newVal);
        }, true);
      }
    };
  });



/** WEBPACK FOOTER **
 ** ./src/directives/nouislider.js
 **/